import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";

export const keyRoutine: BaseKeyFunction = () => ["routine"];
